// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "modal_paper-2hjX5";
var _3 = "root-sFMBr";
var _4 = "header-32E9A";
var _5 = "table-3Paji";
var _6 = "row-2XlWZ";
var _7 = "time-kJyZd";
var _8 = "action-2ck4j";
var _9 = "table_header-ypBlv";
export { _1 as "__esModule", _2 as "modal_paper", _3 as "root", _4 as "header", _5 as "table", _6 as "row", _7 as "time", _8 as "action", _9 as "table_header" }
export default { "__esModule": _1, "modal_paper": _2, "root": _3, "header": _4, "table": _5, "row": _6, "time": _7, "action": _8, "table_header": _9 }
